import React from 'react'
import { connect } from 'react-redux'
import toJS from '../../../containers/general/toJS.js';
import PageNewsletterPage from '../present/PageNewsletterPage';
import getData from '../../../functions/getData.js';
import { PROGRAM_ERROR, PROGRAM_STATUS } from '../../../constants/state.js';

const mapStateToProps = state => ({
    campaignsData: state.getIn(['newsletterServerData', 'campaigns', 'data', 'items']),
    campaignsOrder: state.getIn(['newsletterServerData', 'campaigns', 'data', 'order']),
    programStatus: getData(state, PROGRAM_STATUS),
    programError: getData(state, PROGRAM_ERROR)

})


const PageNewsletter = ({campaignsData, campaignsOrder, goBackPath, programStatus, programError}) => (
    <PageNewsletterPage
        campaignsData={campaignsData}
        campaignsOrder={campaignsOrder}
        goBackPath={goBackPath}
        programStatus={programStatus}
        programError={programError}
    />
)


export default connect(mapStateToProps)(toJS(PageNewsletter))